// A donde aterriza cada quien al entrar. Se calcula en un solo lugar: el Login
// NO debe navegar por su cuenta (lo hacia a '/groups' fijo, mandando al platform
// admin al club en vez de a la plataforma).
export const resolveLandingPath = ({ isPlatformAdmin, isAdmin, isHeadCoach } = {}) => {
  if (isPlatformAdmin) return '/platform'
  if (isAdmin || isHeadCoach) return '/groups'
  return '/hoy'
}
